import { createBrowserRouter } from 'react-router-dom'

import { CurrentUserInfo } from 'utils/userInfo'

import ErrorPage from 'pages/ErrorPage'

import BaseApp from './BaseApp'

export const createAppRouter = (userInfo: CurrentUserInfo) =>
  createBrowserRouter([
    {
      path: '*',
      element: <BaseApp userInfo={userInfo} />,
      errorElement: <ErrorPage />,
    },
  ])
